<template>
  <layout :title="$t(`init.title`)" :desc="$t(`init.desc`)">
    <div class="alert alert-primary" role="alert" v-if="error">
      {{error}}
    </div>
    <form @submit.prevent="init">
      <input class="form-control" type="password" v-model="password" :placeholder="$t(`init.password`)" required :disabled="loading">
      <input class="form-control" type="password" v-model="passwordConfirmation" :placeholder="$t(`init.confirmation`)" required :disabled="loading">
      <div class="form-button full-width">
        <button id="submit" type="submit" class="ibtn btn-forget" :disabled="loading" style="width: 100%;">{{$t(`init.init`)}}</button>
      </div>
    </form>
  </layout>
</template>

<script>
import { mapState } from 'vuex';
import Layout from './Layout';

export default {
  name: "Reset",
  components: {
    Layout,
  },
  data: () => ({
    error: null,
    password: ``,
    passwordConfirmation: ``,
    loading: false,
  }),
  async created () {
    if (!await this.$store.dispatch(`checkChangePassword`, this.$route.params.token)) {
      this.$router.replace({ name: `Login` });
    }
  },
  computed: {
    ...mapState([
        `me`,
    ]),
  },
  methods: {
    checkErrors () {
      this.error = null;
      if (this.password.length < 6) {
        this.error = this.$t(`init.error.length`);
        return false;
      } else if (this.password !== this.passwordConfirmation) {
        this.error = this.$t(`init.error.confirmation`);
        return false;
      }
      return true;
    },
    async init () {
      this.loading = true;
      if (this.checkErrors()) {
        const user = await this.$store.dispatch(`initPassword`, { token: this.$route.params.token,  password: this.password });
        if (user) {
          await this.$store.dispatch(`login`, { email: user.email, password: this.password });
          await this.$store.dispatch(`fetchMe`);
          return window.location.href = this.me.homeUrl;
        } else {
          this.error = this.$t(`init.error.server`);
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>

</style>
